import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { ActivatedRoute, RouterModule, UrlTree } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ThemePalette } from 'shared/enums';
import { BadgeComponent } from '../../atoms';

type LinkType = string[] | string | UrlTree;

@Component({
  selector: 'app-chip-menu',
  templateUrl: './chip-menu.component.html',
  imports: [MatChipListbox, MatChipOption, NgClass, RouterModule, BadgeComponent, TranslateModule, NgForOf, NgIf],
})
export class ChipMenuComponent implements OnInit {
  protected readonly ThemePalette = ThemePalette;

  @Input() public options: IChipMenuOption[] = [];
  @Input() public showCounts = true;

  private currentPath$ = new BehaviorSubject<string | null>(null);

  constructor(private activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {
    this.activatedRoute.url.subscribe((urlSegments) => {
      const currentLastPart = urlSegments.at(-1)?.path || null;
      this.currentPath$.next(currentLastPart);
      this.updateActiveStates();
    });

    this.updateActiveStates();
  }

  private updateActiveStates(): void {
    const currentPath = this.currentPath$.getValue();

    if (currentPath !== null) {
      this.options.forEach((option) => {
        option.isActive = this.getLastSegment(option.value) === currentPath;
      });
    }
  }

  private getLastSegment(link: LinkType): string | null {
    if (Array.isArray(link)) {
      return link.at(-1) || null;
    } else if (typeof link === 'string') {
      return link;
    }
    return null;
  }
}

export interface IChipMenuOption {
  label: string;
  value: LinkType;
  colorClass: string;
  count: number;
  isActive?: boolean;
}
